import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";
import {
  HeadingRTFOverrides,
  MainWidthClassName,
  SecondaryWidthClassName,
} from "../styles";

interface Props {
  text?: IRichTextInformation;
  shape?: IGatsbySvg;
  aside?: IRichTextInformation;
}

export const TextHighlight: React.FC<Props> = (props) => {
  const { text, shape, aside } = props;
  return (
    <section
      data-component="Text Highlight"
      className={classNames("py-100px", "relative", "bg-cotton", "relative")}
    >
      <div className="page-grid max-width relative">
        {shape && (
          <img
            className={classNames(
              "row-span-4 row-start-1 w-full object-contain object-center",
              MainWidthClassName,
            )}
            src={shape.encoded ?? shape.encodedUrl}
            alt=""
          />
        )}
        {text && (
          <RTF
            className={classNames(
              "h3 relative text-hyacinth",
              "row-span-1 row-start-2",
              SecondaryWidthClassName,
            )}
            content={text}
            classNameOverrides={HeadingRTFOverrides}
          />
        )}
        {aside && (
          <RTF
            className={classNames(
              "relative row-span-1 row-start-3 pt-20px text-hyacinth lg:pt-40px",
              SecondaryWidthClassName,
            )}
            content={aside}
            fixedParagraphClassName={"h6"}
          />
        )}
      </div>
    </section>
  );
};
